export default "<img src=\"{{img}}\" style=\"width: 1400px !important;\">";